import { useTranslation } from "react-i18next";

interface Props {
  label?: string;
}

export function ThinkingIndicator({ label }: Props) {
  const { t } = useTranslation("intelligence");
  const text = label ? `${label}…` : t("tool.thinking");
  return (
    <span
      className="inline-block text-sm text-brand animate-pulse"
      aria-label={text}
    >
      {text}
    </span>
  );
}
